import React from 'react';
import {Typography} from 'antd';
import {formatDateAndTimeFromNow} from "@src/helpers/utils";

const { Text } = Typography

const AIProcessorInfoHeader = ({ aiProcessorResponse, pipelineData }: { aiProcessorResponse: any, pipelineData?: any }) => {
    // Only show AI processor info if the response state is OK and history exists
    if (!aiProcessorResponse?.ai_processor_history || aiProcessorResponse?.state !== "OK") {
        return null;
    }

    const history = aiProcessorResponse.ai_processor_history;
    const name = history.name || 'AI Processor';
    const version = history.version ? `version ${history.version}` : '';
    const declarationVersion = pipelineData?.config?.si_declaration?.version;
    const modified = aiProcessorResponse.modified;

    return (
        <div style={{marginBottom: '16px', paddingBottom: '12px', borderBottom: '1px solid #f0f0f0'}}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '16px' }}>
                {/* Left side: AI Processor info */}
                <div style={{ flex: 1 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
                        AI Processor:
                        <span style={{ fontWeight: 'bold' }}>{name}</span>
                        {version && (
                            <span style={{fontSize: '12px', color: '#666', backgroundColor: '#f5f5f5', padding: '2px 6px', borderRadius: '3px'}}>
                                {version}
                            </span>
                        )}
                    </div>
                    {
                        declarationVersion &&
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
                            Service Item Declaration:
                            <span style={{fontSize: '12px', color: '#666', backgroundColor: '#f5f5f5', padding: '2px 6px', borderRadius: '3px'}}>
                                version {declarationVersion}
                            </span>
                        </div>
                    }
                </div>

                {/* Right side: Cost and Modified */}
                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', alignItems: 'flex-end' }}>
                    {modified && (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <Text className='text-sm'>
                                Last Modified: {formatDateAndTimeFromNow(modified)}
                            </Text>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default AIProcessorInfoHeader;
